import React, { useEffect } from 'react';

// STYLES
import {
  Box,
  Fade,
  FormControlLabel,
  Grid,
  Switch,
  Typography,
  useMediaQuery,
} from '@mui/material';

// COMPONENTS
import { ContainerFormSegment } from 'js/components/Clubs/Segmentation/segmentStyles';
import { InputDateStandard } from 'js/components/TriiboComponents/InputDate/InputDateStandard';
import { OutlinedInput } from 'js/components/TriiboComponents/Input/OutlinedInput';
import { StandardSelect } from 'js/components/TriiboComponents/Select/StandardSelect';

export const KeyWarningInformation = ({
  actionOptions,
  alertData,
  alertSettings,
  handleInputs,
  segments,
  showButtonPopup,
  setShowButtonPopup,
}) => {
  const isMdUp = useMediaQuery((theme) => theme.breakpoints.up('md'));

  const options = Object.values(actionOptions).map(({ type, label }) => ({
    id: type,
    name: label,
  }));

  const typeOptions = [
    { id: 'popup', name: 'Pop-up' },
    { id: 'tarja', name: 'Tarja' },
  ];

  const getMaxLengthByType = (type) => {
    switch (type) {
      case 'tarja':
        return 150;
      case 'popup':
        return 400;
      default:
        return undefined;
    }
  };

  useEffect(() => {
    alertData?.url && alertData?.url !== '' && setShowButtonPopup(true);
  }, [alertData]);

  function formatDateForEdit(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  return (
    <ContainerFormSegment
      style={{
        width: alertData.type === '' && isMdUp ? '50%' : '100%',
        margin: '0 auto',
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 700, marginLeft: '5%', marginBottom: '1rem' }}
      >
        Informações principais:
      </Typography>

      <Grid container spacing={2} columnSpacing={2}>
        {/* Tipo */}
        <Grid item md={6} xs={12}>
          <StandardSelect
            label="Tipo"
            menuOptions={typeOptions}
            id="id"
            displayProp="name"
            required
            setValue={handleInputs}
            value={alertData.type}
            width={'100%'}
          />
        </Grid>

        {/* Segmento */}
        <Grid item md={6} xs={12}>
          <StandardSelect
            label="Segmentos"
            menuOptions={segments}
            id="id"
            displayProp="name"
            multiple
            setValue={handleInputs}
            value={alertData.segments || []}
            width={'100%'}
          />
        </Grid>

        {/* Ação */}
        <Grid item md={12} xs={12}>
          <StandardSelect
            label="Ação"
            menuOptions={options}
            id="id"
            displayProp="name"
            required
            setValue={handleInputs}
            value={alertData.action}
            width={'100%'}
          />
        </Grid>

        {/* Titulo */}
        {alertData.type === 'popup' && (
          <Grid item md={12}>
            <OutlinedInput
              label="Título"
              required
              setValue={handleInputs}
              value={alertData.title}
            />
          </Grid>
        )}

        {/* Descrição */}
        <Grid item md={12} xs={12}>
          <OutlinedInput
            fullWidth
            label="Descrição"
            maxLength={getMaxLengthByType(alertData.type)}
            required
            setValue={handleInputs}
            value={alertData.description}
          />
        </Grid>

        {/* URL */}
        {alertData.type === 'tarja' && (
          <Grid item md={12}>
            <OutlinedInput
              fullWidth
              label="Url"
              required
              setValue={handleInputs}
              value={alertData.url}
            />
          </Grid>
        )}

        {/* Datas */}
        <Grid
          item
          md={6}
          xs={12}
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 3 }}
        >
          <InputDateStandard
            label="Data do início"
            required
            setValue={handleInputs}
            value={alertSettings ? formatDateForEdit(alertData.startDate) : alertData.startDate}
          />
        </Grid>
        <Grid
          item
          md={6}
          xs={12}
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 3 }}
        >
          <InputDateStandard
            disabled={alertData.startDate === ''}
            label="Data do fim"
            required
            setValue={handleInputs}
            value={alertSettings ? formatDateForEdit(alertData.endDate) : alertData.endDate}
          />
        </Grid>

        <Fade in={alertData.type === 'popup'} timeout={500}>
          <Box>
            <FormControlLabel
              control={
                <Switch
                  checked={showButtonPopup}
                  onChange={(e) => setShowButtonPopup(e.target.checked)}
                  name="showButton"
                  color="primary"
                />
              }
              label="Exibir botão no pop-up"
            />
          </Box>
        </Fade>
      </Grid>
    </ContainerFormSegment>
  );
};
